/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any; }
  /** The built-in `Decimal` scalar type. */
  Decimal: { input: any; output: any; }
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: any; }
  URL: { input: any; output: any; }
  UUID: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AbandonedCallCampaign = {
  __typename?: 'AbandonedCallCampaign';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AbandonedCallContactInfo = {
  __typename?: 'AbandonedCallContactInfo';
  phoneNumber: Scalars['String']['output'];
};

export type AbandonedCallCustomer = {
  __typename?: 'AbandonedCallCustomer';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AbandonedCallFollowUp = {
  __typename?: 'AbandonedCallFollowUp';
  abandonedCallCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  abandonedCallId?: Maybe<Scalars['String']['output']>;
  abandonedCallUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  campaign?: Maybe<AbandonedCallCampaign>;
  contactCenterId: Scalars['String']['output'];
  contactInfo: AbandonedCallContactInfo;
  customer?: Maybe<AbandonedCallCustomer>;
  followUpCreatedAt: Scalars['DateTime']['output'];
  followUpId: Scalars['String']['output'];
  followUpStatus: FollowUpStatus;
  followUpUpdatedAt: Scalars['DateTime']['output'];
  queue?: Maybe<AbandonedCallQueue>;
  tenant: AbandonedCallTenant;
};

export type AbandonedCallFollowUpFilterInput = {
  assignedToIds?: InputMaybe<Array<Scalars['String']['input']>>;
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contactCenterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  followUpIds?: InputMaybe<Array<Scalars['String']['input']>>;
  followUpStatuses?: InputMaybe<Array<FollowUpStatus>>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  queueIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AbandonedCallFollowUpSortInput = {
  createdAt?: InputMaybe<CustomSortEnumType>;
};

/** A segment of a collection. */
export type AbandonedCallFollowUpsCollectionSegment = {
  __typename?: 'AbandonedCallFollowUpsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<AbandonedCallFollowUp>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type AbandonedCallQueue = {
  __typename?: 'AbandonedCallQueue';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AbandonedCallTenant = {
  __typename?: 'AbandonedCallTenant';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Activity = {
  __typename?: 'Activity';
  createdAt: Scalars['DateTime']['output'];
  externalRef: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: ActivityType;
};

export type ActivityAddInput = {
  externalRef?: InputMaybe<Scalars['String']['input']>;
  type: ActivityType;
};

export enum ActivityType {
  JobBooking = 'JOB_BOOKING'
}

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type AnnouncePositionHoldTreatment = {
  __typename?: 'AnnouncePositionHoldTreatment';
  enabled: Scalars['Boolean']['output'];
};

export type AnnouncePositionHoldTreatmentInput = {
  enabled: Scalars['Boolean']['input'];
};

export type AnnouncePositionHoldTreatmentStep = {
  __typename?: 'AnnouncePositionHoldTreatmentStep';
  type: HoldTreatmentStepType;
};

export type AnnounceWaitHoldTreatment = {
  __typename?: 'AnnounceWaitHoldTreatment';
  enabled: Scalars['Boolean']['output'];
};

export type AnnounceWaitHoldTreatmentInput = {
  enabled: Scalars['Boolean']['input'];
};

export type AnnounceWaitHoldTreatmentStep = {
  __typename?: 'AnnounceWaitHoldTreatmentStep';
  type: HoldTreatmentStepType;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export type Appointment = {
  __typename?: 'Appointment';
  id: Scalars['ID']['output'];
  scheduledDateTime: Scalars['DateTime']['output'];
  status: AppointmentStatus;
};

export enum AppointmentStatus {
  Canceled = 'CANCELED',
  Dispatched = 'DISPATCHED',
  Done = 'DONE',
  Hold = 'HOLD',
  Scheduled = 'SCHEDULED',
  Working = 'WORKING'
}

export enum AssessmentStatus {
  Available = 'AVAILABLE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Unavailable = 'UNAVAILABLE'
}

export type Assignment = {
  __typename?: 'Assignment';
  assignedAt: Scalars['DateTime']['output'];
  assignedToId: Scalars['String']['output'];
};

export type BillToCustomerInput = {
  address: AddressInput;
  contacts?: InputMaybe<Array<ContactUpsertInput>>;
  name: Scalars['String']['input'];
};

export enum CallDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type CallInformation = {
  __typename?: 'CallInformation';
  created: Scalars['DateTime']['output'];
  direction: CallDirection;
  from?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  sid?: Maybe<Scalars['ID']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['ID']['output'];
  to?: Maybe<Scalars['String']['output']>;
};

export type CallReason = {
  __typename?: 'CallReason';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isLead: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tenant: Tenant;
  tenantId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CallReasonSortInput = {
  active?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isLead?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type CallReasonsCollectionSegment = {
  __typename?: 'CallReasonsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CallReason>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type CallTranscript = {
  __typename?: 'CallTranscript';
  call: CallInformation;
  duration: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  recordingUri?: Maybe<Scalars['URL']['output']>;
  transcriptionItems: Array<CallTranscriptRecognition>;
  type: TranscriptType;
};

export type CallTranscriptRecognition = {
  __typename?: 'CallTranscriptRecognition';
  confidence?: Maybe<Scalars['Float']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  duration: Scalars['String']['output'];
  speaker: SpeakerType;
  start: Scalars['String']['output'];
};

export type Campaign = {
  __typename?: 'Campaign';
  active: Scalars['Boolean']['output'];
  businessUnit?: Maybe<Scalars['String']['output']>;
  campaignPhoneNumbers?: Maybe<Array<Scalars['String']['output']>>;
  category?: Maybe<CampaignCategory>;
  id: Scalars['ID']['output'];
  medium?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  otherMedium?: Maybe<Scalars['String']['output']>;
  otherSource?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type CampaignCategory = {
  __typename?: 'CampaignCategory';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CampaignSortInput = {
  id?: InputMaybe<CustomSortEnumType>;
};

/** A segment of a collection. */
export type CampaignsCollectionSegment = {
  __typename?: 'CampaignsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Campaign>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ChannelClassification = {
  __typename?: 'ChannelClassification';
  reasonId?: Maybe<Scalars['ID']['output']>;
  reasonName?: Maybe<Scalars['String']['output']>;
  typeId: Scalars['ID']['output'];
  typeName: Scalars['String']['output'];
};

export type ChannelClassificationInput = {
  reasonId?: InputMaybe<Scalars['ID']['input']>;
  reasonName?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
  typeName?: InputMaybe<Scalars['String']['input']>;
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  id: Scalars['ID']['output'];
  invoiceStatementNotification: Scalars['Boolean']['output'];
  jobRemindersEnabled: Scalars['Boolean']['output'];
  marketingUpdatesEnabled: Scalars['Boolean']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  type: ContactType;
  value: Scalars['String']['output'];
};

export type ContactAddInput = {
  memo?: InputMaybe<Scalars['String']['input']>;
  type: ContactType;
  value: Scalars['String']['input'];
};

export type ContactCenter = {
  __typename?: 'ContactCenter';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** A segment of a collection. */
export type ContactCentersCollectionSegment = {
  __typename?: 'ContactCentersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ContactCenter>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ContactType {
  Email = 'EMAIL',
  Fax = 'FAX',
  MobilePhone = 'MOBILE_PHONE',
  Phone = 'PHONE',
  Unknown = 'UNKNOWN'
}

export type ContactUpdateInput = {
  memo?: InputMaybe<Scalars['String']['input']>;
  type: ContactType;
  value: Scalars['String']['input'];
};

export type ContactUpsertInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  invoiceStatementNotification: Scalars['Boolean']['input'];
  jobRemindersEnabled: Scalars['Boolean']['input'];
  marketingUpdatesEnabled: Scalars['Boolean']['input'];
  memo?: InputMaybe<Scalars['String']['input']>;
  type: ContactType;
  value: Scalars['String']['input'];
};

export type Conversation = {
  __typename?: 'Conversation';
  agentIds: Array<Scalars['ID']['output']>;
  channel: ConversationChannel;
  createdAt: Scalars['DateTime']['output'];
  direction: ConversationDirection;
  id: Scalars['ID']['output'];
  queueIds: Array<Scalars['ID']['output']>;
  sid: Scalars['ID']['output'];
  tenantId: Scalars['Long']['output'];
};

export enum ConversationChannel {
  Phone = 'PHONE'
}

export enum ConversationDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type ConversationsInput = {
  kazooId?: InputMaybe<Scalars['String']['input']>;
};

export type CurrentUser = {
  __typename?: 'CurrentUser';
  accountId: Scalars['ID']['output'];
  available: Scalars['Boolean']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  contactCenter: ContactCenter;
  contactCenterId: Scalars['ID']['output'];
  contactCenterUserId?: Maybe<Scalars['ID']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  org: Org;
  permissions: Array<Scalars['String']['output']>;
  personalLine?: Maybe<UserPersonalLine>;
  queues: Array<UserQueue>;
  roles: Array<UserRole>;
  seatLevel: UserSeatLevel;
  stats?: Maybe<UserStats>;
  status: UserAvailabilityStatus;
  username: Scalars['String']['output'];
  webPhoneToken?: Maybe<Scalars['String']['output']>;
};

export enum CustomSortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Customer = {
  __typename?: 'Customer';
  address: Address;
  contacts: Array<Contact>;
  doNotService: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lifetimeRevenue: Scalars['Float']['output'];
  locations: Array<Location>;
  membership: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  outstandingBalance: Scalars['Float']['output'];
  tags: Array<Tag>;
  tenant: Tenant;
  type: CustomerType;
};

export type CustomerAddInput = {
  address: AddressInput;
  billToCustomer?: InputMaybe<BillToCustomerInput>;
  contacts?: InputMaybe<Array<ContactUpsertInput>>;
  doNotService?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  type: CustomerType;
};

export type CustomerFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** A segment of a collection. */
export type CustomerLocationsCollectionSegment = {
  __typename?: 'CustomerLocationsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Location>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum CustomerType {
  Commercial = 'COMMERCIAL',
  Residential = 'RESIDENTIAL',
  Unknown = 'UNKNOWN'
}

/** A segment of a collection. */
export type CustomersCollectionSegment = {
  __typename?: 'CustomersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Customer>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type DateRangeInput = {
  days?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
};

export type DispatchFee = {
  __typename?: 'DispatchFee';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  price: Scalars['Decimal']['output'];
  tenantId: Scalars['ID']['output'];
};

export type Entrypoint = {
  __typename?: 'Entrypoint';
  type: EntrypointType;
  value: Scalars['String']['output'];
  workflowId?: Maybe<Scalars['ID']['output']>;
};

export enum EntrypointType {
  Call = 'CALL',
  Sms = 'SMS'
}

export type FollowUp = {
  __typename?: 'FollowUp';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  assignment?: Maybe<Assignment>;
  contactCenterId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customerId?: Maybe<Scalars['ID']['output']>;
  customerLocationId?: Maybe<Scalars['ID']['output']>;
  dismissReasonId?: Maybe<Scalars['Long']['output']>;
  followUpType: FollowUpType;
  id: Scalars['ID']['output'];
  metaData?: Maybe<Array<KeyValueObject>>;
  note?: Maybe<FollowUpNote>;
  status: FollowUpStatus;
  tenantId: Scalars['ID']['output'];
  to: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FollowUpDismissInput = {
  callReasonId?: InputMaybe<Scalars['Long']['input']>;
  dismissReason?: InputMaybe<SecondChanceLeadDismissReason>;
};

export enum FollowUpMetaDataKey {
  AbandonedCallId = 'ABANDONED_CALL_ID',
  BookingId = 'BOOKING_ID',
  CallSid = 'CALL_SID',
  SecondChanceLeadId = 'SECOND_CHANCE_LEAD_ID'
}

export type FollowUpNote = {
  __typename?: 'FollowUpNote';
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['String']['output'];
  isCustomerNoteCreated?: Maybe<Scalars['Boolean']['output']>;
  isLocationNoteCreated?: Maybe<Scalars['Boolean']['output']>;
  text: Scalars['String']['output'];
};

export type FollowUpNoteAddInput = {
  addToCustomerId?: InputMaybe<Scalars['ID']['input']>;
  addToLocationId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};

export type FollowUpNoteAddOutput = {
  __typename?: 'FollowUpNoteAddOutput';
  isCustomerNoteCreated?: Maybe<Scalars['Boolean']['output']>;
  isLocationNoteCreated?: Maybe<Scalars['Boolean']['output']>;
  isNoteAdded: Scalars['Boolean']['output'];
};

export enum FollowUpStatus {
  ContactAttempted = 'CONTACT_ATTEMPTED',
  Dismissed = 'DISMISSED',
  FollowUpNeeded = 'FOLLOW_UP_NEEDED',
  New = 'NEW',
  Resolved = 'RESOLVED'
}

export enum FollowUpType {
  AbandonedCall = 'ABANDONED_CALL',
  Booking = 'BOOKING',
  SecondChanceLead = 'SECOND_CHANCE_LEAD',
  VirtualAssistant = 'VIRTUAL_ASSISTANT'
}

export type FollowUpUpdateInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerLocationId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<FollowUpStatus>;
};

export type HoldTreatment = AnnouncePositionHoldTreatment | AnnounceWaitHoldTreatment | PauseHoldTreatment | PlayMediaHoldTreatment;

export type HoldTreatmentStep = AnnouncePositionHoldTreatmentStep | AnnounceWaitHoldTreatmentStep | PauseHoldTreatmentStep | PlayMediaHoldTreatmentStep;

export type HoldTreatmentStepInput = {
  mediaId?: InputMaybe<Scalars['UUID']['input']>;
  type: HoldTreatmentStepType;
  waitTime?: InputMaybe<Scalars['String']['input']>;
};

export enum HoldTreatmentStepType {
  AnnouncePosition = 'ANNOUNCE_POSITION',
  AnnounceWait = 'ANNOUNCE_WAIT',
  Pause = 'PAUSE',
  PlayMedia = 'PLAY_MEDIA'
}

export type HoldTreatmentsInput = {
  announcePositionHoldTreatment?: InputMaybe<AnnouncePositionHoldTreatmentInput>;
  announceWaitHoldTreatment?: InputMaybe<AnnounceWaitHoldTreatmentInput>;
  pauseHoldTreatment?: InputMaybe<PauseHoldTreatmentInput>;
  playMediaHoldTreatment?: InputMaybe<PlayMediaHoldTreatmentInput>;
};

export type Interaction = {
  __typename?: 'Interaction';
  activities: Array<Activity>;
  agentNotes?: Maybe<Scalars['String']['output']>;
  archived: Scalars['Boolean']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated This property is obsolete. Please use 'ChannelClassification.ReasonId' instead. Should be deleted after FrontEnd will be updated */
  callReasonId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated This property is obsolete. Please use 'ChannelClassification.ReasonName' instead. Should be deleted after FrontEnd will be updated */
  callReasonName?: Maybe<Scalars['String']['output']>;
  /** @deprecated This property is obsolete. Please use 'ChannelClassification.TypeId' instead. Should be deleted after FrontEnd will be updated */
  callTypeId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated This property is obsolete. Please use 'ChannelClassification.TypeName' instead. Should be deleted after FrontEnd will be updated */
  callTypeName?: Maybe<Scalars['String']['output']>;
  channel: InteractionChannel;
  channelClassification?: Maybe<ChannelClassification>;
  contactCenter: ContactCenter;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  createdByName: Scalars['String']['output'];
  customerId?: Maybe<Scalars['ID']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sentiment?: Maybe<InteractionSentiment>;
  sessionId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: InteractionStatus;
  summary?: Maybe<InteractionSummary>;
  tenantId: Scalars['ID']['output'];
  tenantName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum InteractionChannel {
  InboundText = 'INBOUND_TEXT',
  InboundVoice = 'INBOUND_VOICE',
  OutboundText = 'OUTBOUND_TEXT',
  OutboundVoice = 'OUTBOUND_VOICE',
  Unknown = 'UNKNOWN'
}

export enum InteractionChannelType {
  Text = 'TEXT',
  Unknown = 'UNKNOWN',
  Voice = 'VOICE'
}

export type InteractionFilterInput = {
  archived?: InputMaybe<YesNoAnyInput>;
  channelClassificationReasonIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  channelClassificationTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  channelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  channelTypes?: InputMaybe<Array<InteractionChannelType>>;
  channels?: InputMaybe<Array<InteractionChannel>>;
  contactCenterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<DateRangeInput>;
  createdByIds?: InputMaybe<Array<Scalars['String']['input']>>;
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  displayIds?: InputMaybe<Array<Scalars['String']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
  sentimentMoods?: InputMaybe<Array<InteractionSentimentMood>>;
  sessionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startedAt?: InputMaybe<DateRangeInput>;
  statuses?: InputMaybe<Array<InteractionStatus>>;
  tenantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<DateRangeInput>;
};

export type InteractionSentiment = {
  __typename?: 'InteractionSentiment';
  assessment?: Maybe<InteractionSentimentAssessment>;
  sentimentMood?: Maybe<InteractionSentimentMood>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type InteractionSentimentAssessment = {
  __typename?: 'InteractionSentimentAssessment';
  sentimentMood?: Maybe<InteractionSentimentMood>;
  status: AssessmentStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum InteractionSentimentMood {
  Happy = 'HAPPY',
  Neutral = 'NEUTRAL',
  Unhappy = 'UNHAPPY'
}

export enum InteractionStatus {
  Completed = 'COMPLETED',
  Open = 'OPEN',
  Unknown = 'UNKNOWN'
}

export type InteractionSummary = {
  __typename?: 'InteractionSummary';
  isAccurate?: Maybe<Scalars['Boolean']['output']>;
  status: AssessmentStatus;
  summary: Scalars['String']['output'];
  updatedById?: Maybe<Scalars['ID']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type InteractionUpdateInput = {
  agentNotes?: InputMaybe<Scalars['String']['input']>;
  channelClassification?: InputMaybe<ChannelClassificationInput>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  durationSeconds?: InputMaybe<Scalars['Float']['input']>;
  sentimentMood?: InputMaybe<InteractionSentimentMood>;
  status?: InputMaybe<InteractionStatus>;
  summaryIsAccurate?: InputMaybe<Scalars['Boolean']['input']>;
  summaryText?: InputMaybe<Scalars['String']['input']>;
};

export type InteractionUpsertInput = {
  activities?: InputMaybe<Array<ActivityAddInput>>;
  agentNotes?: InputMaybe<Scalars['String']['input']>;
  channel: InteractionChannel;
  channelClassification?: InputMaybe<ChannelClassificationInput>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  durationSeconds?: InputMaybe<Scalars['Float']['input']>;
  from: Scalars['String']['input'];
  sentimentMood?: InputMaybe<InteractionSentimentMood>;
  status?: InputMaybe<InteractionStatus>;
  summaryIsAccurate?: InputMaybe<Scalars['Boolean']['input']>;
  summaryText?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
  tenantName: Scalars['String']['input'];
};

/** A segment of a collection. */
export type InteractionsCollectionSegment = {
  __typename?: 'InteractionsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Interaction>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type InteractionsSortInput = {
  callReason?: InputMaybe<CustomSortEnumType>;
  callType?: InputMaybe<CustomSortEnumType>;
  createdAt?: InputMaybe<CustomSortEnumType>;
  customerName?: InputMaybe<CustomSortEnumType>;
  duration?: InputMaybe<CustomSortEnumType>;
  startedAt?: InputMaybe<CustomSortEnumType>;
  status?: InputMaybe<CustomSortEnumType>;
  tenantName?: InputMaybe<CustomSortEnumType>;
  updatedAt?: InputMaybe<CustomSortEnumType>;
};

export type Job = {
  __typename?: 'Job';
  address: Scalars['String']['output'];
  appointments: Array<Appointment>;
  businessUnitName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  jobType: Scalars['String']['output'];
  locationId: Scalars['ID']['output'];
  tenantId: Scalars['ID']['output'];
};

export type JobType = {
  __typename?: 'JobType';
  defaultCases: Array<Scalars['String']['output']>;
  defaultDescription: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type JobTypeFilterInput = {
  and?: InputMaybe<Array<JobTypeFilterInput>>;
  defaultCases?: InputMaybe<ListStringOperationFilterInput>;
  defaultDescription?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<JobTypeFilterInput>>;
};

export type JobTypeSortInput = {
  defaultDescription?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type JobTypesCollectionSegment = {
  __typename?: 'JobTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<JobType>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type JobsCollectionSegment = {
  __typename?: 'JobsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Job>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type KeyValueObject = {
  __typename?: 'KeyValueObject';
  key: FollowUpMetaDataKey;
  value: Scalars['String']['output'];
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type Location = {
  __typename?: 'Location';
  active: Scalars['Boolean']['output'];
  address: Address;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type LocationFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type Media = {
  __typename?: 'Media';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateWorkflow: Scalars['Boolean']['output'];
  addCustomer: Customer;
  /** @deprecated This mutation is obsolete. Please use 'UpsertCustomerContactAsync' instead. */
  addCustomerContact: Contact;
  addFollowUpNote: FollowUpNoteAddOutput;
  addQueue: Queue;
  addUserQueue: User;
  bulkConnectVirtualAgentsAcp: VirtualAgentBulkAcpConnection;
  bulkDisconnectVirtualAgentsAcp: VirtualAgentBulkAcpDisconnection;
  connectVirtualAgentAcp: Scalars['Boolean']['output'];
  createWorkflow: Workflow;
  /** @deprecated This mutation is obsolete. Please use 'UpsertCustomerContactAsync' instead. */
  deleteCustomerContact: Scalars['Boolean']['output'];
  deleteMedia: Scalars['Boolean']['output'];
  deleteQueue: Scalars['Boolean']['output'];
  deleteWorkflow: Scalars['Boolean']['output'];
  disconnectVirtualAgentAcp: Scalars['Boolean']['output'];
  performRecordingAction: Scalars['Boolean']['output'];
  removeUserQueue: User;
  revertInteractionCallSummary: Scalars['String']['output'];
  setUserStatus: Scalars['Boolean']['output'];
  /** @deprecated This mutation is obsolete. Please use 'UpsertCustomerContactAsync' instead. */
  updateCustomerContact: Contact;
  updateFollowUp: FollowUp;
  updateFollowUpDismiss: FollowUp;
  updateInteraction: Interaction;
  updateQueue: Queue;
  updateSecondChanceLead: SecondChanceLead;
  updateUser: User;
  updateUserQueue: User;
  updateVirtualAgentAccountSettings: VirtualAgentAccountSettings;
  updateWorkflow: Workflow;
  uploadMedia: Media;
  upsertCustomerContact: Scalars['Boolean']['output'];
  upsertInteractionByChannelId: Interaction;
  upsertLocationContact: Scalars['Boolean']['output'];
};


export type MutationActivateWorkflowArgs = {
  workflowId: Scalars['ID']['input'];
};


export type MutationAddCustomerArgs = {
  input: CustomerAddInput;
  tenantId: Scalars['ID']['input'];
};


export type MutationAddCustomerContactArgs = {
  customerId: Scalars['ID']['input'];
  input: ContactAddInput;
  tenantId: Scalars['ID']['input'];
};


export type MutationAddFollowUpNoteArgs = {
  followUpId: Scalars['ID']['input'];
  input: FollowUpNoteAddInput;
  tenantId: Scalars['ID']['input'];
};


export type MutationAddQueueArgs = {
  input: QueueAddInput;
};


export type MutationAddUserQueueArgs = {
  queueId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationConnectVirtualAgentAcpArgs = {
  tenantId: Scalars['ID']['input'];
};


export type MutationCreateWorkflowArgs = {
  input: WorkflowInput;
};


export type MutationDeleteCustomerContactArgs = {
  customerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};


export type MutationDeleteMediaArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQueueArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorkflowArgs = {
  workflowId: Scalars['ID']['input'];
};


export type MutationDisconnectVirtualAgentAcpArgs = {
  tenantId: Scalars['ID']['input'];
};


export type MutationPerformRecordingActionArgs = {
  action: RecordingAction;
  kazooCallId: Scalars['String']['input'];
};


export type MutationRemoveUserQueueArgs = {
  queueId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRevertInteractionCallSummaryArgs = {
  interactionId: Scalars['ID']['input'];
};


export type MutationSetUserStatusArgs = {
  status: UserSetAvailabilityStatus;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateCustomerContactArgs = {
  customerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: ContactUpdateInput;
  tenantId: Scalars['ID']['input'];
};


export type MutationUpdateFollowUpArgs = {
  followUpId: Scalars['ID']['input'];
  input: FollowUpUpdateInput;
};


export type MutationUpdateFollowUpDismissArgs = {
  followUpId: Scalars['ID']['input'];
  input: FollowUpDismissInput;
};


export type MutationUpdateInteractionArgs = {
  input: InteractionUpdateInput;
  interactionId: Scalars['ID']['input'];
};


export type MutationUpdateQueueArgs = {
  input: QueueUpdateInput;
  queueId: Scalars['ID']['input'];
};


export type MutationUpdateSecondChanceLeadArgs = {
  input: SecondChanceLeadUpdateInput;
  sclId: Scalars['ID']['input'];
};


export type MutationUpdateUserArgs = {
  input: UserUpdateInput;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateUserQueueArgs = {
  input: UserQueueUpdateInput;
  queueId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdateVirtualAgentAccountSettingsArgs = {
  input: UpdateVirtualAgentAccountSettingsInput;
  tenantId: Scalars['ID']['input'];
};


export type MutationUpdateWorkflowArgs = {
  input: WorkflowInput;
  workflowId: Scalars['ID']['input'];
};


export type MutationUploadMediaArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUpsertCustomerContactArgs = {
  customerId: Scalars['ID']['input'];
  input: Array<ContactUpsertInput>;
  tenantId: Scalars['ID']['input'];
};


export type MutationUpsertInteractionByChannelIdArgs = {
  channelId: Scalars['ID']['input'];
  input: InteractionUpsertInput;
};


export type MutationUpsertLocationContactArgs = {
  input: Array<ContactUpsertInput>;
  locationId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};

export type Org = {
  __typename?: 'Org';
  hasActiveContract: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tenants: Array<Tenant>;
};

export type PauseHoldTreatment = {
  __typename?: 'PauseHoldTreatment';
  enabled: Scalars['Boolean']['output'];
  wait: Scalars['String']['output'];
};

export type PauseHoldTreatmentInput = {
  enabled: Scalars['Boolean']['input'];
  wait: Scalars['String']['input'];
};

export type PauseHoldTreatmentStep = {
  __typename?: 'PauseHoldTreatmentStep';
  type: HoldTreatmentStepType;
  waitTime?: Maybe<Scalars['String']['output']>;
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  number: Scalars['ID']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
  workflowIds: Array<Scalars['ID']['output']>;
};

export type PlayMediaHoldTreatment = {
  __typename?: 'PlayMediaHoldTreatment';
  enabled: Scalars['Boolean']['output'];
  mediaId: Scalars['UUID']['output'];
};

export type PlayMediaHoldTreatmentInput = {
  enabled: Scalars['Boolean']['input'];
  mediaId: Scalars['UUID']['input'];
};

export type PlayMediaHoldTreatmentStep = {
  __typename?: 'PlayMediaHoldTreatmentStep';
  mediaId: Scalars['ID']['output'];
  type: HoldTreatmentStepType;
};

export type Query = {
  __typename?: 'Query';
  abandonedCallFollowUps?: Maybe<AbandonedCallFollowUpsCollectionSegment>;
  addressDetails: Address;
  autocompleteAddress: SuggestedAddressesResponse;
  callReasons?: Maybe<CallReasonsCollectionSegment>;
  callTranscript?: Maybe<CallTranscript>;
  campaigns?: Maybe<CampaignsCollectionSegment>;
  channelClassification?: Maybe<ChannelClassification>;
  contactCenterPhoneNumbers: Array<PhoneNumber>;
  contactCenters?: Maybe<ContactCentersCollectionSegment>;
  conversations: Array<Conversation>;
  currentUser: CurrentUser;
  customer?: Maybe<Customer>;
  customerLocations?: Maybe<CustomerLocationsCollectionSegment>;
  customers?: Maybe<CustomersCollectionSegment>;
  dispatchFees: Array<DispatchFee>;
  entrypoints: Array<Entrypoint>;
  interaction: Interaction;
  interactions?: Maybe<InteractionsCollectionSegment>;
  job?: Maybe<Job>;
  jobTypes?: Maybe<JobTypesCollectionSegment>;
  jobs?: Maybe<JobsCollectionSegment>;
  location?: Maybe<Location>;
  locationContacts: Array<Contact>;
  media?: Maybe<Media>;
  queue?: Maybe<Queue>;
  queues?: Maybe<QueuesCollectionSegment>;
  secondChanceLeadFollowUps?: Maybe<SecondChanceLeadFollowUpsCollectionSegment>;
  tenant?: Maybe<Tenant>;
  tenantRedirectUrl: Scalars['String']['output'];
  user?: Maybe<User>;
  userRoles?: Maybe<UserRolesCollectionSegment>;
  users?: Maybe<UsersCollectionSegment>;
  validateAddress: Scalars['Boolean']['output'];
  virtualAgentAccountJobTypeDetails?: Maybe<VirtualAgentAccountJobTypeDetailsCollectionSegment>;
  virtualAgentAvailableBusinessUnits?: Maybe<VirtualAgentAvailableBusinessUnitsCollectionSegment>;
  virtualAgentBulkAcpConnection: VirtualAgentBulkAcpConnection;
  virtualAgentSettings?: Maybe<VirtualAgentSettingsCollectionSegment>;
  workflow?: Maybe<Workflow>;
  workflows?: Maybe<WorkflowsCollectionSegment>;
};


export type QueryAbandonedCallFollowUpsArgs = {
  filter?: InputMaybe<AbandonedCallFollowUpFilterInput>;
  order?: InputMaybe<AbandonedCallFollowUpSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAddressDetailsArgs = {
  placeId: Scalars['String']['input'];
  sessionToken: Scalars['String']['input'];
};


export type QueryAutocompleteAddressArgs = {
  input: Scalars['String']['input'];
  sessionToken: Scalars['String']['input'];
};


export type QueryCallReasonsArgs = {
  order?: InputMaybe<Array<CallReasonSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCallTranscriptArgs = {
  interactionId: Scalars['ID']['input'];
};


export type QueryCampaignsArgs = {
  order?: InputMaybe<CampaignSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['ID']['input'];
};


export type QueryChannelClassificationArgs = {
  channelId: Scalars['ID']['input'];
  channelType: InteractionChannel;
  tenantId: Scalars['ID']['input'];
};


export type QueryContactCentersArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConversationsArgs = {
  input: ConversationsInput;
};


export type QueryCustomerArgs = {
  id: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};


export type QueryCustomerLocationsArgs = {
  customerId: Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['ID']['input'];
  where?: InputMaybe<LocationFilterInput>;
};


export type QueryCustomersArgs = {
  order?: InputMaybe<ServiceTitanSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<CustomerFilterInput>;
};


export type QueryDispatchFeesArgs = {
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
  tenantId: Scalars['ID']['input'];
};


export type QueryInteractionArgs = {
  interactionId: Scalars['ID']['input'];
};


export type QueryInteractionsArgs = {
  order?: InputMaybe<InteractionsSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InteractionFilterInput>;
};


export type QueryJobArgs = {
  jobId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};


export type QueryJobTypesArgs = {
  order?: InputMaybe<Array<JobTypeSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['ID']['input'];
  where?: InputMaybe<JobTypeFilterInput>;
};


export type QueryJobsArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  jobNumber?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['ID']['input'];
};


export type QueryLocationArgs = {
  locationId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};


export type QueryLocationContactsArgs = {
  locationId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};


export type QueryMediaArgs = {
  mediaId: Scalars['ID']['input'];
};


export type QueryQueueArgs = {
  queueId: Scalars['ID']['input'];
};


export type QueryQueuesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySecondChanceLeadFollowUpsArgs = {
  filter?: InputMaybe<SecondChanceLeadFollowUpFilterInput>;
  order?: InputMaybe<SecondChanceLeadFollowUpSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTenantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTenantRedirectUrlArgs = {
  id: Scalars['ID']['input'];
  path: Scalars['String']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserRolesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryValidateAddressArgs = {
  address: AddressInput;
};


export type QueryVirtualAgentAccountJobTypeDetailsArgs = {
  accountId: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVirtualAgentAvailableBusinessUnitsArgs = {
  accountId: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVirtualAgentSettingsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWorkflowArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkflowsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type Queue = {
  __typename?: 'Queue';
  agentTimeout: Scalars['String']['output'];
  entrypoints: Array<Scalars['String']['output']>;
  forceAway?: Maybe<Scalars['Int']['output']>;
  holdTreatmentFlow: Array<HoldTreatmentStep>;
  holdTreatments: QueueHoldTreatments;
  id: Scalars['ID']['output'];
  inboundRecording: RecordingPreference;
  memberIds: Array<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  outboundRecording: RecordingPreference;
  recoveryTime?: Maybe<Scalars['String']['output']>;
  rolloverSettings?: Maybe<RolloverSettings>;
  routingStrategy: RoutingStrategy;
  sessions: Array<QueueSession>;
  status: QueueStatus;
};

export type QueueAddInput = {
  agentTimeout: Scalars['String']['input'];
  entrypoints?: InputMaybe<Array<Scalars['String']['input']>>;
  forceAway?: InputMaybe<Scalars['Int']['input']>;
  holdTreatmentFlow?: InputMaybe<Array<HoldTreatmentStepInput>>;
  holdTreatments: HoldTreatmentsInput;
  inboundRecording: RecordingPreference;
  memberIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  name: Scalars['String']['input'];
  outboundRecording: RecordingPreference;
  recoveryTime?: InputMaybe<Scalars['String']['input']>;
  rolloverSettings?: InputMaybe<RolloverSettingsInput>;
  routingStrategy: RoutingStrategy;
};

export type QueueHoldTreatments = {
  __typename?: 'QueueHoldTreatments';
  announcePositionHoldTreatment?: Maybe<AnnouncePositionHoldTreatment>;
  announceWaitHoldTreatment?: Maybe<AnnounceWaitHoldTreatment>;
  pauseHoldTreatment?: Maybe<PauseHoldTreatment>;
  playMediaHoldTreatment?: Maybe<PlayMediaHoldTreatment>;
};

export type QueueRolloverDestination = {
  __typename?: 'QueueRolloverDestination';
  queueId: Scalars['UUID']['output'];
  type: RolloverDestinationType;
};

export type QueueRolloverDestinationInput = {
  queueId: Scalars['ID']['input'];
};

export type QueueSession = {
  __typename?: 'QueueSession';
  enteredAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type QueueStatus = {
  __typename?: 'QueueStatus';
  abandonedSessions: Scalars['Int']['output'];
  activeRecipientCount: Scalars['Int']['output'];
  activeSessionCount: Scalars['Int']['output'];
  availableRecipientCount: Scalars['Int']['output'];
  averageWait: Scalars['Int']['output'];
  estimatedWait: Scalars['Int']['output'];
  longestWait: Scalars['Int']['output'];
  missedSessions: Scalars['Int']['output'];
  recipientCount: Scalars['Int']['output'];
  totalSessions: Scalars['Int']['output'];
};

export type QueueUpdateInput = {
  agentTimeout: Scalars['String']['input'];
  forceAway?: InputMaybe<Scalars['Int']['input']>;
  holdTreatmentFlow?: InputMaybe<Array<HoldTreatmentStepInput>>;
  holdTreatments: HoldTreatmentsInput;
  inboundRecording: RecordingPreference;
  name: Scalars['String']['input'];
  outboundRecording: RecordingPreference;
  recoveryTime?: InputMaybe<Scalars['String']['input']>;
  rolloverSettings?: InputMaybe<RolloverSettingsInput>;
  routingStrategy: RoutingStrategy;
};

/** A segment of a collection. */
export type QueuesCollectionSegment = {
  __typename?: 'QueuesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Queue>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum RecordingAction {
  Pause = 'PAUSE',
  Resume = 'RESUME',
  Start = 'START',
  Stop = 'STOP'
}

export enum RecordingPreference {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
  Never = 'NEVER'
}

export type RolloverDestination = QueueRolloverDestination | VoiceMailRolloverDestination | WorkflowRolloverDestination;

export enum RolloverDestinationType {
  Queue = 'QUEUE',
  VoiceMail = 'VOICE_MAIL',
  Workflow = 'WORKFLOW'
}

export type RolloverSettings = {
  __typename?: 'RolloverSettings';
  destination?: Maybe<RolloverDestination>;
  timeout: Scalars['String']['output'];
};

export type RolloverSettingsInput = {
  queueRolloverDestination?: InputMaybe<QueueRolloverDestinationInput>;
  timeout: Scalars['String']['input'];
  type?: InputMaybe<RolloverDestinationType>;
  voiceMailRolloverDestination?: InputMaybe<VoiceMailRolloverDestinationInput>;
  workflowRolloverDestination?: InputMaybe<WorkflowRolloverDestinationInput>;
};

export enum RoutingStrategy {
  LeastCalls = 'LEAST_CALLS',
  LeastOffers = 'LEAST_OFFERS',
  MostIdle = 'MOST_IDLE',
  RingAll = 'RING_ALL',
  RoundRobin = 'ROUND_ROBIN'
}

export type SecondChanceLead = {
  __typename?: 'SecondChanceLead';
  id: Scalars['String']['output'];
};

export type SecondChanceLeadAgent = {
  __typename?: 'SecondChanceLeadAgent';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SecondChanceLeadCall = {
  __typename?: 'SecondChanceLeadCall';
  endedAt: Scalars['DateTime']['output'];
  sid: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export type SecondChanceLeadCallReason = {
  __typename?: 'SecondChanceLeadCallReason';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SecondChanceLeadContactInfo = {
  __typename?: 'SecondChanceLeadContactInfo';
  phoneNumber: Scalars['String']['output'];
};

export type SecondChanceLeadCustomer = {
  __typename?: 'SecondChanceLeadCustomer';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum SecondChanceLeadDismissReason {
  LeadNotFollowingUp = 'LEAD_NOT_FOLLOWING_UP',
  ReviewedNotALead = 'REVIEWED_NOT_A_LEAD'
}

export type SecondChanceLeadFollowUp = {
  __typename?: 'SecondChanceLeadFollowUp';
  agent: SecondChanceLeadAgent;
  agentNote?: Maybe<Scalars['String']['output']>;
  call: SecondChanceLeadCall;
  callReason: SecondChanceLeadCallReason;
  contactCenterId: Scalars['String']['output'];
  contactInfo: SecondChanceLeadContactInfo;
  customer?: Maybe<SecondChanceLeadCustomer>;
  followUpCreatedAt: Scalars['DateTime']['output'];
  followUpId: Scalars['String']['output'];
  followUpStatus: FollowUpStatus;
  followUpUpdatedAt: Scalars['DateTime']['output'];
  location?: Maybe<SecondChanceLeadLocation>;
  note?: Maybe<Scalars['String']['output']>;
  secondChanceLeadCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  secondChanceLeadId: Scalars['String']['output'];
  secondChanceLeadStatus: SecondChanceLeadStatus;
  secondChanceLeadUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  tenant: SecondChanceLeadTenant;
  type: SecondChanceLeadType;
};

export type SecondChanceLeadFollowUpFilterInput = {
  agentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  assignedToIds?: InputMaybe<Array<Scalars['String']['input']>>;
  callReasonIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contactCenterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  followUpIds?: InputMaybe<Array<Scalars['String']['input']>>;
  followUpStatuses?: InputMaybe<Array<FollowUpStatus>>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  secondChanceLeadStatuses?: InputMaybe<Array<SecondChanceLeadStatus>>;
  tenantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  types?: InputMaybe<Array<SecondChanceLeadType>>;
};

export type SecondChanceLeadFollowUpSortInput = {
  createdAt?: InputMaybe<CustomSortEnumType>;
};

/** A segment of a collection. */
export type SecondChanceLeadFollowUpsCollectionSegment = {
  __typename?: 'SecondChanceLeadFollowUpsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<SecondChanceLeadFollowUp>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type SecondChanceLeadLocation = {
  __typename?: 'SecondChanceLeadLocation';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum SecondChanceLeadStatus {
  Expired = 'EXPIRED',
  JobBookedByScl = 'JOB_BOOKED_BY_SCL',
  JobBookedElsewhere = 'JOB_BOOKED_ELSEWHERE',
  LeadCallbackAttempted = 'LEAD_CALLBACK_ATTEMPTED',
  LeadNotAbleToSave = 'LEAD_NOT_ABLE_TO_SAVE',
  LeadNotFollowingUp = 'LEAD_NOT_FOLLOWING_UP',
  New = 'NEW',
  ReviewedNotALead = 'REVIEWED_NOT_A_LEAD'
}

export type SecondChanceLeadTenant = {
  __typename?: 'SecondChanceLeadTenant';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum SecondChanceLeadType {
  Abandoned = 'ABANDONED',
  Booked = 'BOOKED',
  Excused = 'EXCUSED',
  NotLead = 'NOT_LEAD',
  Unbooked = 'UNBOOKED'
}

export type SecondChanceLeadUpdateInput = {
  status?: InputMaybe<SecondChanceLeadStatus>;
};

export type ServiceTitanSortInput = {
  createdAt?: InputMaybe<CustomSortEnumType>;
  id?: InputMaybe<CustomSortEnumType>;
  updatedAt?: InputMaybe<CustomSortEnumType>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SpeakerType {
  Customer = 'CUSTOMER',
  CustomerServiceRepresentative = 'CUSTOMER_SERVICE_REPRESENTATIVE',
  Technician = 'TECHNICIAN',
  Unknown = 'UNKNOWN'
}

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  placeholder: Scalars['Int']['output'];
};

export type SuggestedAddress = {
  __typename?: 'SuggestedAddress';
  placeId: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type SuggestedAddressesResponse = {
  __typename?: 'SuggestedAddressesResponse';
  suggestions: Array<SuggestedAddress>;
};

export type Tag = {
  __typename?: 'Tag';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Tenant = {
  __typename?: 'Tenant';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum TranscriptType {
  PostCall = 'POST_CALL',
  RealTime = 'REAL_TIME'
}

export type UpdateVirtualAgentAccountSettingsInput = {
  closingMessage: Scalars['String']['input'];
  customerFacingBusinessName: Scalars['String']['input'];
  openingMessage: Scalars['String']['input'];
  virtualAgentName: Scalars['String']['input'];
  virtualAgentVoice: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  available: Scalars['Boolean']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  contactCenterUserId?: Maybe<Scalars['ID']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<UserPermission>;
  personalLine?: Maybe<UserPersonalLine>;
  queues: Array<UserQueue>;
  roles: Array<UserRole>;
  seatLevel: UserSeatLevel;
  stats?: Maybe<UserStats>;
  status: UserAvailabilityStatus;
  username: Scalars['String']['output'];
};

export enum UserAvailabilityStatus {
  Available = 'AVAILABLE',
  AwayFromDesk = 'AWAY_FROM_DESK',
  Break = 'BREAK',
  CallOffer = 'CALL_OFFER',
  ExtendedWrapUp = 'EXTENDED_WRAP_UP',
  Offline = 'OFFLINE',
  OnACall = 'ON_A_CALL',
  Unavailable = 'UNAVAILABLE',
  WrapUp = 'WRAP_UP'
}

export type UserPermission = {
  __typename?: 'UserPermission';
  description: Scalars['String']['output'];
  hasPermission: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  providedBy: Array<UserRole>;
};

export type UserPersonalLine = {
  __typename?: 'UserPersonalLine';
  brand: Scalars['String']['output'];
  description: Scalars['String']['output'];
  e911Address?: Maybe<Address>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  recordingPreference: RecordingPreference;
};

export type UserQueue = {
  __typename?: 'UserQueue';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UserQueueUpdateInput = {
  active: Scalars['Boolean']['input'];
};

export type UserRole = {
  __typename?: 'UserRole';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  source: UserRoleSource;
};

export enum UserRoleSource {
  EnterpriseHub = 'ENTERPRISE_HUB',
  TenantOnly = 'TENANT_ONLY'
}

/** A segment of a collection. */
export type UserRolesCollectionSegment = {
  __typename?: 'UserRolesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<UserRole>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum UserSeatLevel {
  Advanced = 'ADVANCED',
  Basic = 'BASIC',
  Free = 'FREE'
}

export enum UserSetAvailabilityStatus {
  Available = 'AVAILABLE',
  AwayFromDesk = 'AWAY_FROM_DESK',
  Break = 'BREAK',
  ExtendedWrapUp = 'EXTENDED_WRAP_UP',
  Offline = 'OFFLINE',
  Unavailable = 'UNAVAILABLE'
}

export type UserStats = {
  __typename?: 'UserStats';
  avgCallTime: Scalars['Float']['output'];
  lastActionAt: Scalars['DateTime']['output'];
  lastHandledAt: Scalars['DateTime']['output'];
  lastIdleAt: Scalars['DateTime']['output'];
  loginAt: Scalars['DateTime']['output'];
  missedSessions: Scalars['Int']['output'];
  offeredSessions: Scalars['Int']['output'];
  totalSessions: Scalars['Int']['output'];
};

export type UserUpdateInput = {
  e911Address?: InputMaybe<AddressInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  recordingPreference?: InputMaybe<RecordingPreference>;
  seatLevel?: InputMaybe<UserSeatLevel>;
};

/** A segment of a collection. */
export type UsersCollectionSegment = {
  __typename?: 'UsersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type VirtualAgentAccountBusinessUnits = {
  __typename?: 'VirtualAgentAccountBusinessUnits';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type VirtualAgentAccountJobTypeDetails = {
  __typename?: 'VirtualAgentAccountJobTypeDetails';
  businessUnitId?: Maybe<Scalars['Int']['output']>;
  businessUnitName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dispatchFee?: Maybe<Scalars['Float']['output']>;
  jobTypeId: Scalars['Int']['output'];
  jobTypeName: Scalars['String']['output'];
  standardJobTypeMappingId?: Maybe<Scalars['Int']['output']>;
  standardJobTypeMappingName?: Maybe<Scalars['String']['output']>;
  virtualAgentCanBook: Scalars['Boolean']['output'];
};

/** A segment of a collection. */
export type VirtualAgentAccountJobTypeDetailsCollectionSegment = {
  __typename?: 'VirtualAgentAccountJobTypeDetailsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<VirtualAgentAccountJobTypeDetails>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type VirtualAgentAccountSettings = {
  __typename?: 'VirtualAgentAccountSettings';
  closingMessage: Scalars['String']['output'];
  customerFacingBusinessName: Scalars['String']['output'];
  openingMessage: Scalars['String']['output'];
  virtualAgentName: Scalars['String']['output'];
  virtualAgentVoice: Scalars['String']['output'];
};

/** A segment of a collection. */
export type VirtualAgentAvailableBusinessUnitsCollectionSegment = {
  __typename?: 'VirtualAgentAvailableBusinessUnitsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<VirtualAgentAccountBusinessUnits>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type VirtualAgentBulkAcpConnection = {
  __typename?: 'VirtualAgentBulkAcpConnection';
  connectedCount: Scalars['Int']['output'];
};

export type VirtualAgentBulkAcpDisconnection = {
  __typename?: 'VirtualAgentBulkAcpDisconnection';
  disconnectedCount: Scalars['Int']['output'];
};

export type VirtualAgentSetting = {
  __typename?: 'VirtualAgentSetting';
  accountId: Scalars['String']['output'];
  accountName: Scalars['String']['output'];
  adjustableCapacityPlanning: Scalars['Boolean']['output'];
  customerFacingBusinessName: Scalars['String']['output'];
  jobTypeDetails: Scalars['Boolean']['output'];
  virtualAgent: Scalars['String']['output'];
};

/** A segment of a collection. */
export type VirtualAgentSettingsCollectionSegment = {
  __typename?: 'VirtualAgentSettingsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<VirtualAgentSetting>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type VoiceMailRolloverDestination = {
  __typename?: 'VoiceMailRolloverDestination';
  type: RolloverDestinationType;
  vmBoxId: Scalars['UUID']['output'];
};

export type VoiceMailRolloverDestinationInput = {
  vmBoxId: Scalars['ID']['input'];
};

export type Workflow = {
  __typename?: 'Workflow';
  accounts: Array<WorkflowAccount>;
  channels: Array<WorkflowChannel>;
  endpoints: Array<WorkflowEndpoint>;
  entrypoints: Array<WorkflowEntrypoint>;
  flow?: Maybe<Scalars['Any']['output']>;
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  metadata: WorkflowMetadata;
  name: Scalars['String']['output'];
};

export type WorkflowAccount = {
  __typename?: 'WorkflowAccount';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum WorkflowChannel {
  Calls = 'CALLS',
  Email = 'EMAIL'
}

export type WorkflowEndpoint = {
  __typename?: 'WorkflowEndpoint';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type WorkflowEntrypoint = {
  __typename?: 'WorkflowEntrypoint';
  tenant: Tenant;
  tenantId: Scalars['ID']['output'];
  type: EntrypointType;
  value: Scalars['String']['output'];
};

export type WorkflowEntrypointInput = {
  type: EntrypointType;
  value: Scalars['String']['input'];
};

export type WorkflowInput = {
  entrypoints: Array<WorkflowEntrypointInput>;
  flow?: InputMaybe<Scalars['Any']['input']>;
  isPublished: Scalars['Boolean']['input'];
  metadata: WorkflowMetadataInput;
  name: Scalars['String']['input'];
};

export type WorkflowListItem = {
  __typename?: 'WorkflowListItem';
  accounts: Array<WorkflowAccount>;
  channels: Array<WorkflowChannel>;
  endpoints: Array<WorkflowEndpoint>;
  entrypoints: Array<WorkflowEntrypoint>;
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  metadata: WorkflowMetadata;
  name: Scalars['String']['output'];
};

export type WorkflowMetadata = {
  __typename?: 'WorkflowMetadata';
  hasCallForwarding: Scalars['Boolean']['output'];
  hasVoicemail: Scalars['Boolean']['output'];
  isMissingEndpoint: Scalars['Boolean']['output'];
  queueIds: Array<Scalars['String']['output']>;
  type: WorkflowType;
};

export type WorkflowMetadataInput = {
  hasCallForwarding: Scalars['Boolean']['input'];
  hasVoicemail: Scalars['Boolean']['input'];
  isMissingEndpoint: Scalars['Boolean']['input'];
  queueIds: Array<Scalars['ID']['input']>;
  type: WorkflowType;
};

export type WorkflowRolloverDestination = {
  __typename?: 'WorkflowRolloverDestination';
  type: RolloverDestinationType;
  workflowId: Scalars['UUID']['output'];
};

export type WorkflowRolloverDestinationInput = {
  workflowId: Scalars['ID']['input'];
};

export enum WorkflowType {
  Text = 'TEXT',
  Voice = 'VOICE'
}

/** A segment of a collection. */
export type WorkflowsCollectionSegment = {
  __typename?: 'WorkflowsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkflowListItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum YesNoAnyInput {
  Any = 'ANY',
  No = 'NO',
  Yes = 'YES'
}

export type CallReasonsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CallReasonsQuery = { __typename?: 'Query', callReasons?: { __typename?: 'CallReasonsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CallReason', id: string, name: string, isLead: boolean, active: boolean, tenantId: string }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetAllCallReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCallReasonsQuery = { __typename?: 'Query', callReasons?: { __typename?: 'CallReasonsCollectionSegment', items?: Array<{ __typename?: 'CallReason', tenantId: string, id: string, name: string, isLead: boolean, active: boolean, tenant: { __typename?: 'Tenant', id: string, name: string } }> | null } | null };

export type GetCustomerContactsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
}>;


export type GetCustomerContactsQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: string, name: string, contacts: Array<{ __typename?: 'Contact', id: string, type: ContactType, value: string, memo?: string | null, jobRemindersEnabled: boolean, marketingUpdatesEnabled: boolean, invoiceStatementNotification: boolean }> } | null };

export type GetCustomerByIdQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
}>;


export type GetCustomerByIdQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: string, name: string, type: CustomerType, lifetimeRevenue: number, outstandingBalance: number, membership: boolean, contacts: Array<{ __typename?: 'Contact', id: string, type: ContactType, value: string, memo?: string | null, jobRemindersEnabled: boolean, marketingUpdatesEnabled: boolean, invoiceStatementNotification: boolean }>, locations: Array<{ __typename?: 'Location', id: string, active: boolean, name?: string | null, address: { __typename?: 'Address', street: string, unit?: string | null, city: string, state: string, zip: string, country?: string | null } }>, tags: Array<{ __typename?: 'Tag', name: string, color: string }> } | null };

export type GetTenantNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTenantNameQuery = { __typename?: 'Query', tenant?: { __typename?: 'Tenant', name: string } | null };

export type TenantRedirectUrlQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  path: Scalars['String']['input'];
}>;


export type TenantRedirectUrlQuery = { __typename?: 'Query', tenantRedirectUrl: string };

export type GetUsersForOutboundModalEmployeeTableQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersForOutboundModalEmployeeTableQuery = { __typename?: 'Query', users?: { __typename?: 'UsersCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'User', id: string, name: string, email: string, personalLine?: { __typename?: 'UserPersonalLine', phoneNumber?: string | null } | null }> | null } | null };

export type PerformRecordingActionMutationVariables = Exact<{
  kazooCallId: Scalars['String']['input'];
  action: RecordingAction;
}>;


export type PerformRecordingActionMutation = { __typename?: 'Mutation', performRecordingAction: boolean };

export type AutocompleteAddressQueryVariables = Exact<{
  input: Scalars['String']['input'];
  sessionToken: Scalars['String']['input'];
}>;


export type AutocompleteAddressQuery = { __typename?: 'Query', autocompleteAddress: { __typename?: 'SuggestedAddressesResponse', suggestions: Array<{ __typename?: 'SuggestedAddress', placeId: string, text: string }> } };

export type AddressDetailsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
  sessionToken: Scalars['String']['input'];
}>;


export type AddressDetailsQuery = { __typename?: 'Query', addressDetails: { __typename?: 'Address', street: string, unit?: string | null, city: string, state: string, country?: string | null, zip: string, latitude?: number | null, longitude?: number | null } };

export type CurrentServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentServicesQuery = { __typename?: 'Query', contactCenters?: { __typename?: 'ContactCentersCollectionSegment', items?: Array<{ __typename?: 'ContactCenter', id: string, name: string }> | null } | null };

export type CurrentUserQueryVariables = Exact<{
  refreshOnly: Scalars['Boolean']['input'];
}>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', accountId: string, contactCenterId: string, id: string, name: string, permissions: Array<string>, webPhoneToken?: string | null, contactCenterUserId?: string | null, email?: string, seatLevel: UserSeatLevel, status?: UserAvailabilityStatus, username?: string, contactCenter?: { __typename?: 'ContactCenter', id: string, name: string }, org: { __typename?: 'Org', hasActiveContract: boolean, id: string, name: string, tenants: Array<{ __typename?: 'Tenant', id: string, name: string }> }, personalLine?: { __typename?: 'UserPersonalLine', brand: string, description: string, phoneNumber?: string | null, recordingPreference: RecordingPreference, e911Address?: { __typename?: 'Address', city: string, country?: string | null, latitude?: number | null, longitude?: number | null, state: string, street: string, unit?: string | null, zip: string } | null } | null } };

export type UpsertInteractionByChannelIdMutationVariables = Exact<{
  channelId: Scalars['ID']['input'];
  input: InteractionUpsertInput;
}>;


export type UpsertInteractionByChannelIdMutation = { __typename?: 'Mutation', upsertInteractionByChannelId: { __typename?: 'Interaction', id: string, status: InteractionStatus, contactCenter: { __typename?: 'ContactCenter', id: string, name: string } } };

export type GetServiceQueuesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServiceQueuesQueryQuery = { __typename?: 'Query', queues?: { __typename?: 'QueuesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Queue', id: string, entrypoints: Array<string>, name: string, memberIds: Array<string>, inboundRecording: RecordingPreference, outboundRecording: RecordingPreference, status: { __typename?: 'QueueStatus', activeRecipientCount: number, availableRecipientCount: number, estimatedWait: number, averageWait: number, longestWait: number, recipientCount: number, activeSessionCount: number, totalSessions: number, missedSessions: number, abandonedSessions: number }, sessions: Array<{ __typename?: 'QueueSession', id: string, name: string, position: number, enteredAt: any }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetServiceUsersQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServiceUsersQueryQuery = { __typename?: 'Query', users?: { __typename?: 'UsersCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'User', id: string, contactCenterUserId?: string | null, name: string, email: string, available: boolean, status: UserAvailabilityStatus, stats?: { __typename?: 'UserStats', totalSessions: number, offeredSessions: number, missedSessions: number, avgCallTime: number, loginAt: any, lastActionAt: any, lastHandledAt: any, lastIdleAt: any } | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type ConversationsQueryVariables = Exact<{
  input: ConversationsInput;
}>;


export type ConversationsQuery = { __typename?: 'Query', conversations: Array<{ __typename?: 'Conversation', id: string, sid: string, queueIds: Array<string> }> };

export type SetUserStatusMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  status: UserSetAvailabilityStatus;
}>;


export type SetUserStatusMutation = { __typename?: 'Mutation', setUserStatus: boolean };

export type UpsertCustomerContactsMutationVariables = Exact<{
  input: Array<ContactUpsertInput> | ContactUpsertInput;
  tenantId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
}>;


export type UpsertCustomerContactsMutation = { __typename?: 'Mutation', upsertCustomerContact: boolean };

export type AddCustomerMutationVariables = Exact<{
  input: CustomerAddInput;
  tenantId: Scalars['ID']['input'];
}>;


export type AddCustomerMutation = { __typename?: 'Mutation', addCustomer: { __typename?: 'Customer', id: string, name: string, type: CustomerType } };

export type GetCustomerBySearchQueryVariables = Exact<{
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<CustomerFilterInput>;
}>;


export type GetCustomerBySearchQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersCollectionSegment', items?: Array<{ __typename?: 'Customer', id: string, name: string, type: CustomerType, contacts: Array<{ __typename?: 'Contact', id: string, type: ContactType, value: string, memo?: string | null, jobRemindersEnabled: boolean, marketingUpdatesEnabled: boolean, invoiceStatementNotification: boolean }>, locations: Array<{ __typename?: 'Location', id: string, active: boolean, name?: string | null, address: { __typename?: 'Address', street: string, unit?: string | null, city: string, state: string, zip: string, country?: string | null } }>, tenant: { __typename?: 'Tenant', id: string, name: string } }> | null } | null };

export type GetCustomerLocationsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
}>;


export type GetCustomerLocationsQuery = { __typename?: 'Query', customerLocations?: { __typename?: 'CustomerLocationsCollectionSegment', items?: Array<{ __typename?: 'Location', id: string, name?: string | null, active: boolean, address: { __typename?: 'Address', street: string, unit?: string | null, city: string, state: string, zip: string, country?: string | null, latitude?: number | null, longitude?: number | null } }> | null } | null };

export type CustomerJobBookingDetailsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
}>;


export type CustomerJobBookingDetailsQuery = { __typename?: 'Query', job?: { __typename?: 'Job', address: string, businessUnitName: string, id: string, jobType: string, tenantId: string, locationId: string, appointments: Array<{ __typename?: 'Appointment', id: string, scheduledDateTime: any, status: AppointmentStatus }> } | null };

export type GetConversationDetailsRecordingAndTranscriptQueryVariables = Exact<{
  interactionId: Scalars['ID']['input'];
}>;


export type GetConversationDetailsRecordingAndTranscriptQuery = { __typename?: 'Query', callTranscript?: { __typename?: 'CallTranscript', recordingUri?: any | null, transcriptionItems: Array<{ __typename?: 'CallTranscriptRecognition', content?: string | null, duration: string, start: string, speaker: SpeakerType }> } | null };

export type InteractionQueryVariables = Exact<{
  interactionId: Scalars['ID']['input'];
}>;


export type InteractionQuery = { __typename?: 'Query', interaction: { __typename?: 'Interaction', id: string, tenantName: string, tenantId: string, customerName?: string | null, customerId?: string | null, from: string, createdAt: any, startedAt?: any | null, channel: InteractionChannel, durationSeconds?: number | null, createdByName: string, createdBy: string, displayId: string, status: InteractionStatus, activities: Array<{ __typename?: 'Activity', createdAt: any, externalRef: string, id: string, type: ActivityType }>, summary?: { __typename?: 'InteractionSummary', isAccurate?: boolean | null, status: AssessmentStatus, summary: string, updatedById?: string | null, updatedByName?: string | null } | null, sentiment?: { __typename?: 'InteractionSentiment', sentimentMood?: InteractionSentimentMood | null } | null, channelClassification?: { __typename?: 'ChannelClassification', reasonId?: string | null, reasonName?: string | null, typeId: string, typeName: string } | null } };

export type UpdateInteractionMutationVariables = Exact<{
  interactionId: Scalars['ID']['input'];
  input: InteractionUpdateInput;
}>;


export type UpdateInteractionMutation = { __typename?: 'Mutation', updateInteraction: { __typename?: 'Interaction', id: string, displayId: string, createdAt: any, createdBy: string, createdByName: string, channel: InteractionChannel, tenantName: string, tenantId: string, customerName?: string | null, customerId?: string | null, durationSeconds?: number | null, callTypeId?: string | null, callTypeName?: string | null, callReasonId?: string | null, callReasonName?: string | null, sentiment?: { __typename?: 'InteractionSentiment', sentimentMood?: InteractionSentimentMood | null } | null, summary?: { __typename?: 'InteractionSummary', isAccurate?: boolean | null, status: AssessmentStatus, summary: string, updatedById?: string | null, updatedByName?: string | null } | null } };

export type RevertInteractionCallSummaryMutationVariables = Exact<{
  interactionId: Scalars['ID']['input'];
}>;


export type RevertInteractionCallSummaryMutation = { __typename?: 'Mutation', revertInteractionCallSummary: string };

export type AgentsQueryVariables = Exact<{ [key: string]: never; }>;


export type AgentsQuery = { __typename?: 'Query', users?: { __typename?: 'UsersCollectionSegment', items?: Array<{ __typename?: 'User', id: string, avatar?: string | null, name: string }> | null } | null };

export type InteractionsQueryVariables = Exact<{
  where?: InputMaybe<InteractionFilterInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<InteractionsSortInput>;
}>;


export type InteractionsQuery = { __typename?: 'Query', interactions?: { __typename?: 'InteractionsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Interaction', id: string, createdAt: any, startedAt?: any | null, updatedAt: any, archived: boolean, sessionId?: string | null, channel: InteractionChannel, status: InteractionStatus, tenantName: string, customerName?: string | null, createdBy: string, createdByName: string, durationSeconds?: number | null, from: string, sentiment?: { __typename?: 'InteractionSentiment', sentimentMood?: InteractionSentimentMood | null } | null, channelClassification?: { __typename?: 'ChannelClassification', reasonName?: string | null, typeName: string } | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type InteractionsCountQueryVariables = Exact<{
  where?: InputMaybe<InteractionFilterInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InteractionsCountQuery = { __typename?: 'Query', interactions?: { __typename?: 'InteractionsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UserDetailPermissionsFragment = { __typename?: 'User', permissions: Array<{ __typename?: 'UserPermission', id: string, name: string, description: string, hasPermission: boolean, providedBy: Array<{ __typename?: 'UserRole', id: string, name: string }> }> } & { ' $fragmentName'?: 'UserDetailPermissionsFragment' };

export type UserDetailQueuesFragment = { __typename?: 'User', contactCenterUserId?: string | null, queues: Array<{ __typename?: 'UserQueue', id: string, name: string, active: boolean }> } & { ' $fragmentName'?: 'UserDetailQueuesFragment' };

export type UserPossibleQueuesFragment = { __typename?: 'Query', queues?: { __typename?: 'QueuesCollectionSegment', items?: Array<{ __typename?: 'Queue', id: string, name: string }> | null } | null } & { ' $fragmentName'?: 'UserPossibleQueuesFragment' };

export type UserDetailOverviewFragment = { __typename?: 'User', name: string, seatLevel: UserSeatLevel, roles: Array<{ __typename?: 'UserRole', id: string, name: string, source: UserRoleSource }> } & { ' $fragmentName'?: 'UserDetailOverviewFragment' };

export type UserDetailPersonalLineFragment = { __typename?: 'User', seatLevel: UserSeatLevel, name: string, personalLine?: { __typename?: 'UserPersonalLine', phoneNumber?: string | null, brand: string, description: string, recordingPreference: RecordingPreference, e911Address?: { __typename?: 'Address', street: string, unit?: string | null, city: string, state: string, zip: string, country?: string | null, latitude?: number | null, longitude?: number | null } | null } | null } & { ' $fragmentName'?: 'UserDetailPersonalLineFragment' };

export type UserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserQuery = (
  { __typename?: 'Query', user?: (
    { __typename?: 'User', id: string, avatar?: string | null, seatLevel: UserSeatLevel }
    & { ' $fragmentRefs'?: { 'UserDetailPersonalLineFragment': UserDetailPersonalLineFragment;'UserDetailQueuesFragment': UserDetailQueuesFragment;'UserDetailOverviewFragment': UserDetailOverviewFragment;'UserDetailPermissionsFragment': UserDetailPermissionsFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'UserPossibleQueuesFragment': UserPossibleQueuesFragment } }
);

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  seatLevel?: InputMaybe<UserSeatLevel>;
  recordingPreference?: InputMaybe<RecordingPreference>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  e911Address?: InputMaybe<AddressInput>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: (
    { __typename?: 'User', id: string, seatLevel: UserSeatLevel }
    & { ' $fragmentRefs'?: { 'UserDetailPersonalLineFragment': UserDetailPersonalLineFragment } }
  ) };

export type AddUserQueueMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  queueId: Scalars['ID']['input'];
}>;


export type AddUserQueueMutation = { __typename?: 'Mutation', addUserQueue: (
    { __typename?: 'User', id: string }
    & { ' $fragmentRefs'?: { 'UserDetailQueuesFragment': UserDetailQueuesFragment } }
  ) };

export type RemoveUserQueueMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  queueId: Scalars['ID']['input'];
}>;


export type RemoveUserQueueMutation = { __typename?: 'Mutation', removeUserQueue: (
    { __typename?: 'User', id: string }
    & { ' $fragmentRefs'?: { 'UserDetailQueuesFragment': UserDetailQueuesFragment } }
  ) };

export type UpdateUserQueueMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  queueId: Scalars['ID']['input'];
  input: UserQueueUpdateInput;
}>;


export type UpdateUserQueueMutation = { __typename?: 'Mutation', updateUserQueue: (
    { __typename?: 'User', id: string }
    & { ' $fragmentRefs'?: { 'UserDetailQueuesFragment': UserDetailQueuesFragment } }
  ) };

export type GetPhoneNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPhoneNumbersQuery = { __typename?: 'Query', contactCenterPhoneNumbers: Array<{ __typename?: 'PhoneNumber', number: string, userId?: string | null, workflowIds: Array<string> }> };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users?: { __typename?: 'UsersCollectionSegment', items?: Array<{ __typename?: 'User', id: string, avatar?: string | null, name: string, seatLevel: UserSeatLevel, personalLine?: { __typename?: 'UserPersonalLine', phoneNumber?: string | null, e911Address?: { __typename?: 'Address', city: string, country?: string | null, latitude?: number | null, longitude?: number | null, state: string, street: string, unit?: string | null, zip: string } | null } | null, roles: Array<{ __typename?: 'UserRole', id: string, name: string, source: UserRoleSource }>, queues: Array<{ __typename?: 'UserQueue', id: string, name: string }> }> | null } | null, userRoles?: { __typename?: 'UserRolesCollectionSegment', items?: Array<{ __typename?: 'UserRole', id: string, name: string, source: UserRoleSource }> | null } | null, queues?: { __typename?: 'QueuesCollectionSegment', items?: Array<{ __typename?: 'Queue', id: string, name: string }> | null } | null };

export type ValidateAddressQueryVariables = Exact<{
  address: AddressInput;
}>;


export type ValidateAddressQuery = { __typename?: 'Query', validateAddress: boolean };

export type VirtualAgentsDefaultSettingsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type VirtualAgentsDefaultSettingsQueryQuery = { __typename: 'Query' };

export type ConnectVirtualAgentAcpMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type ConnectVirtualAgentAcpMutation = { __typename?: 'Mutation', connectVirtualAgentAcp: boolean };

export type DisconnectVirtualAgentAcpMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type DisconnectVirtualAgentAcpMutation = { __typename?: 'Mutation', disconnectVirtualAgentAcp: boolean };

export type AddQueueMutationVariables = Exact<{
  input: QueueAddInput;
}>;


export type AddQueueMutation = { __typename?: 'Mutation', addQueue: { __typename?: 'Queue', id: string, name: string, rolloverSettings?: { __typename?: 'RolloverSettings', timeout: string } | null } };

export type MediaQueryVariables = Exact<{
  mediaId: Scalars['ID']['input'];
}>;


export type MediaQuery = { __typename?: 'Query', media?: { __typename?: 'Media', id: string, name: string } | null };

export type QueueQueryVariables = Exact<{
  queueId: Scalars['ID']['input'];
}>;


export type QueueQuery = { __typename?: 'Query', queue?: { __typename?: 'Queue', agentTimeout: string, entrypoints: Array<string>, forceAway?: number | null, id: string, inboundRecording: RecordingPreference, memberIds: Array<string>, name: string, outboundRecording: RecordingPreference, routingStrategy: RoutingStrategy, holdTreatments: { __typename?: 'QueueHoldTreatments', announcePositionHoldTreatment?: { __typename?: 'AnnouncePositionHoldTreatment', enabled: boolean } | null, announceWaitHoldTreatment?: { __typename?: 'AnnounceWaitHoldTreatment', enabled: boolean } | null, pauseHoldTreatment?: { __typename?: 'PauseHoldTreatment', enabled: boolean, wait: string } | null, playMediaHoldTreatment?: { __typename?: 'PlayMediaHoldTreatment', enabled: boolean, mediaId: any } | null }, rolloverSettings?: { __typename?: 'RolloverSettings', timeout: string, destination?: { __typename?: 'QueueRolloverDestination', queueId: any, type: RolloverDestinationType } | { __typename?: 'VoiceMailRolloverDestination', type: RolloverDestinationType, vmBoxId: any } | { __typename?: 'WorkflowRolloverDestination', type: RolloverDestinationType, workflowId: any } | null } | null, sessions: Array<{ __typename?: 'QueueSession', enteredAt: any, id: string, name: string, position: number }>, status: { __typename?: 'QueueStatus', abandonedSessions: number, activeRecipientCount: number, activeSessionCount: number, availableRecipientCount: number, averageWait: number, estimatedWait: number, longestWait: number, missedSessions: number, recipientCount: number, totalSessions: number } } | null };

export type GetQueuesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQueuesQuery = { __typename?: 'Query', queues?: { __typename?: 'QueuesCollectionSegment', items?: Array<{ __typename?: 'Queue', id: string, name: string, rolloverSettings?: { __typename?: 'RolloverSettings', timeout: string } | null }> | null } | null };

export type UserPhonesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPhonesQuery = { __typename?: 'Query', users?: { __typename?: 'UsersCollectionSegment', items?: Array<{ __typename?: 'User', id: string, contactCenterUserId?: string | null, name: string, seatLevel: UserSeatLevel, personalLine?: { __typename?: 'UserPersonalLine', phoneNumber?: string | null } | null }> | null } | null };

export type UpdateQueueMutationVariables = Exact<{
  queueId: Scalars['ID']['input'];
  input: QueueUpdateInput;
}>;


export type UpdateQueueMutation = { __typename?: 'Mutation', updateQueue: { __typename?: 'Queue', id: string, name: string, rolloverSettings?: { __typename?: 'RolloverSettings', timeout: string } | null } };

export type UploadMediaMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadMediaMutation = { __typename?: 'Mutation', uploadMedia: { __typename?: 'Media', id: string, name: string } };

export type CreateWorkflowMutationVariables = Exact<{
  input: WorkflowInput;
}>;


export type CreateWorkflowMutation = { __typename?: 'Mutation', createWorkflow: { __typename?: 'Workflow', id: string } };

export type GetEntrypointsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEntrypointsQuery = { __typename?: 'Query', entrypoints: Array<{ __typename?: 'Entrypoint', value: string, type: EntrypointType, workflowId?: string | null }> };

export type GetWorkflowsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkflowsQuery = { __typename?: 'Query', workflows?: { __typename?: 'WorkflowsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'WorkflowListItem', id: string, name: string, isPublished: boolean, channels: Array<WorkflowChannel>, entrypoints: Array<{ __typename?: 'WorkflowEntrypoint', type: EntrypointType, value: string, tenantId: string, tenant: { __typename?: 'Tenant', id: string, name: string } }>, endpoints: Array<{ __typename?: 'WorkflowEndpoint', name: string }>, accounts: Array<{ __typename?: 'WorkflowAccount', id: string, name: string }>, metadata: { __typename?: 'WorkflowMetadata', hasCallForwarding: boolean, hasVoicemail: boolean, isMissingEndpoint: boolean, queueIds: Array<string>, type: WorkflowType } }> | null } | null };

export type GetWorkflowsQueuesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkflowsQueuesQuery = { __typename?: 'Query', workflows?: { __typename?: 'WorkflowsCollectionSegment', items?: Array<{ __typename?: 'WorkflowListItem', metadata: { __typename?: 'WorkflowMetadata', queueIds: Array<string> } }> | null } | null };

export type GetWorkflowQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWorkflowQuery = { __typename?: 'Query', workflow?: { __typename?: 'Workflow', id: string, name: string, flow?: any | null, isPublished: boolean, entrypoints: Array<{ __typename?: 'WorkflowEntrypoint', type: EntrypointType, value: string }>, metadata: { __typename?: 'WorkflowMetadata', hasCallForwarding: boolean, hasVoicemail: boolean, isMissingEndpoint: boolean, queueIds: Array<string>, type: WorkflowType } } | null };

export type UpdateWorkflowMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: WorkflowInput;
}>;


export type UpdateWorkflowMutation = { __typename?: 'Mutation', updateWorkflow: { __typename?: 'Workflow', id: string, name: string, isPublished: boolean, flow?: any | null, entrypoints: Array<{ __typename?: 'WorkflowEntrypoint', type: EntrypointType, value: string }> } };

export type DeleteWorkflowMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteWorkflowMutation = { __typename?: 'Mutation', deleteWorkflow: boolean };

export type ActivateWorkflowMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActivateWorkflowMutation = { __typename?: 'Mutation', activateWorkflow: boolean };

export type AbandonedCallsQueryVariables = Exact<{
  filter?: InputMaybe<AbandonedCallFollowUpFilterInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<AbandonedCallFollowUpSortInput>;
}>;


export type AbandonedCallsQuery = { __typename?: 'Query', abandonedCallFollowUps?: { __typename?: 'AbandonedCallFollowUpsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'AbandonedCallFollowUp', followUpId: string, abandonedCallId?: string | null, contactCenterId: string, followUpStatus: FollowUpStatus, followUpCreatedAt: any, followUpUpdatedAt: any, abandonedCallCreatedAt?: any | null, abandonedCallUpdatedAt?: any | null, tenant: { __typename?: 'AbandonedCallTenant', id: string, name?: string | null }, queue?: { __typename?: 'AbandonedCallQueue', id: string, name?: string | null } | null, contactInfo: { __typename?: 'AbandonedCallContactInfo', phoneNumber: string }, customer?: { __typename?: 'AbandonedCallCustomer', id: string, name?: string | null } | null, campaign?: { __typename?: 'AbandonedCallCampaign', id: string, name?: string | null } | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UpdateFollowUpDismissMutationVariables = Exact<{
  followUpId: Scalars['ID']['input'];
  input: FollowUpDismissInput;
}>;


export type UpdateFollowUpDismissMutation = { __typename?: 'Mutation', updateFollowUpDismiss: { __typename?: 'FollowUp', archivedAt?: any | null, contactCenterId: string, createdAt: any, customerId?: string | null, dismissReasonId?: any | null, followUpType: FollowUpType, id: string, status: FollowUpStatus, tenantId: string, to: string, updatedAt: any } };

export type UpdateFollowUpMutationVariables = Exact<{
  followUpId: Scalars['ID']['input'];
  input: FollowUpUpdateInput;
}>;


export type UpdateFollowUpMutation = { __typename?: 'Mutation', updateFollowUp: { __typename?: 'FollowUp', archivedAt?: any | null, contactCenterId: string, customerId?: string | null, dismissReasonId?: any | null, followUpType: FollowUpType, id: string, status: FollowUpStatus, tenantId: string, to: string, createdAt: any, updatedAt: any, assignment?: { __typename?: 'Assignment', assignedAt: any, assignedToId: string } | null, metaData?: Array<{ __typename?: 'KeyValueObject', key: FollowUpMetaDataKey, value: string }> | null } };

export type CampaignsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['ID']['input'];
  order?: InputMaybe<CampaignSortInput>;
}>;


export type CampaignsQuery = { __typename?: 'Query', campaigns?: { __typename?: 'CampaignsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Campaign', id: string, name: string }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type QueuesQueryVariables = Exact<{ [key: string]: never; }>;


export type QueuesQuery = { __typename?: 'Query', queues?: { __typename?: 'QueuesCollectionSegment', items?: Array<{ __typename?: 'Queue', id: string, name: string }> | null } | null };

export type SecondChanceLeadsQueryVariables = Exact<{
  filter?: InputMaybe<SecondChanceLeadFollowUpFilterInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SecondChanceLeadFollowUpSortInput>;
}>;


export type SecondChanceLeadsQuery = { __typename?: 'Query', secondChanceLeadFollowUps?: { __typename?: 'SecondChanceLeadFollowUpsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'SecondChanceLeadFollowUp', followUpId: string, secondChanceLeadId: string, contactCenterId: string, followUpStatus: FollowUpStatus, secondChanceLeadStatus: SecondChanceLeadStatus, type: SecondChanceLeadType, agentNote?: string | null, note?: string | null, followUpCreatedAt: any, followUpUpdatedAt: any, secondChanceLeadCreatedAt?: any | null, secondChanceLeadUpdatedAt?: any | null, tenant: { __typename?: 'SecondChanceLeadTenant', id: string, name?: string | null }, contactInfo: { __typename?: 'SecondChanceLeadContactInfo', phoneNumber: string }, customer?: { __typename?: 'SecondChanceLeadCustomer', id: string, name?: string | null } | null, location?: { __typename?: 'SecondChanceLeadLocation', id: string, name?: string | null } | null, callReason: { __typename?: 'SecondChanceLeadCallReason', id: string, name?: string | null }, agent: { __typename?: 'SecondChanceLeadAgent', id: string, name?: string | null }, call: { __typename?: 'SecondChanceLeadCall', sid: string, startedAt: any, endedAt: any } }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export const UserDetailPermissionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"hasPermission"}},{"kind":"Field","name":{"kind":"Name","value":"providedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UserDetailPermissionsFragment, unknown>;
export const UserDetailQueuesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailQueues"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactCenterUserId"}},{"kind":"Field","name":{"kind":"Name","value":"queues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<UserDetailQueuesFragment, unknown>;
export const UserPossibleQueuesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPossibleQueues"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UserPossibleQueuesFragment, unknown>;
export const UserDetailOverviewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seatLevel"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]} as unknown as DocumentNode<UserDetailOverviewFragment, unknown>;
export const UserDetailPersonalLineFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailPersonalLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seatLevel"}},{"kind":"Field","name":{"kind":"Name","value":"personalLine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"e911Address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recordingPreference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<UserDetailPersonalLineFragment, unknown>;
export const CallReasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"callReasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callReasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isLead"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CallReasonsQuery, CallReasonsQueryVariables>;
export const GetAllCallReasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllCallReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isLead"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllCallReasonsQuery, GetAllCallReasonsQueryVariables>;
export const GetCustomerContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomerContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"memo"}},{"kind":"Field","name":{"kind":"Name","value":"jobRemindersEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"marketingUpdatesEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceStatementNotification"}}]}}]}}]}}]} as unknown as DocumentNode<GetCustomerContactsQuery, GetCustomerContactsQueryVariables>;
export const GetCustomerByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomerById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"memo"}},{"kind":"Field","name":{"kind":"Name","value":"jobRemindersEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"marketingUpdatesEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceStatementNotification"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lifetimeRevenue"}},{"kind":"Field","name":{"kind":"Name","value":"outstandingBalance"}},{"kind":"Field","name":{"kind":"Name","value":"membership"}}]}}]}}]} as unknown as DocumentNode<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>;
export const GetTenantNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTenantName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetTenantNameQuery, GetTenantNameQueryVariables>;
export const TenantRedirectUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tenantRedirectUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenantRedirectUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}]}]}}]} as unknown as DocumentNode<TenantRedirectUrlQuery, TenantRedirectUrlQueryVariables>;
export const GetUsersForOutboundModalEmployeeTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUsersForOutboundModalEmployeeTable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"personalLine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetUsersForOutboundModalEmployeeTableQuery, GetUsersForOutboundModalEmployeeTableQueryVariables>;
export const PerformRecordingActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"performRecordingAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kazooCallId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"action"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingAction"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"performRecordingAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"kazooCallId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kazooCallId"}}},{"kind":"Argument","name":{"kind":"Name","value":"action"},"value":{"kind":"Variable","name":{"kind":"Name","value":"action"}}}]}]}}]} as unknown as DocumentNode<PerformRecordingActionMutation, PerformRecordingActionMutationVariables>;
export const AutocompleteAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"autocompleteAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autocompleteAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"sessionToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeId"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]} as unknown as DocumentNode<AutocompleteAddressQuery, AutocompleteAddressQueryVariables>;
export const AddressDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"addressDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"placeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"placeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sessionToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]} as unknown as DocumentNode<AddressDetailsQuery, AddressDetailsQueryVariables>;
export const CurrentServicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"currentServices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactCenters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CurrentServicesQuery, CurrentServicesQueryVariables>;
export const CurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"currentUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refreshOnly"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"contactCenterId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"webPhoneToken"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshOnly"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"contactCenter"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshOnly"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasActiveContract"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactCenterUserId"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshOnly"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"email"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshOnly"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"personalLine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"recordingPreference"}},{"kind":"Field","name":{"kind":"Name","value":"e911Address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seatLevel"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshOnly"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"username"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshOnly"}}}]}]}]}}]}}]} as unknown as DocumentNode<CurrentUserQuery, CurrentUserQueryVariables>;
export const UpsertInteractionByChannelIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertInteractionByChannelId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InteractionUpsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertInteractionByChannelId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"contactCenter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpsertInteractionByChannelIdMutation, UpsertInteractionByChannelIdMutationVariables>;
export const GetServiceQueuesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getServiceQueuesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entrypoints"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeRecipientCount"}},{"kind":"Field","name":{"kind":"Name","value":"availableRecipientCount"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedWait"}},{"kind":"Field","name":{"kind":"Name","value":"averageWait"}},{"kind":"Field","name":{"kind":"Name","value":"longestWait"}},{"kind":"Field","name":{"kind":"Name","value":"recipientCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeSessionCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalSessions"}},{"kind":"Field","name":{"kind":"Name","value":"missedSessions"}},{"kind":"Field","name":{"kind":"Name","value":"abandonedSessions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberIds"}},{"kind":"Field","name":{"kind":"Name","value":"sessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"enteredAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inboundRecording"}},{"kind":"Field","name":{"kind":"Name","value":"outboundRecording"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetServiceQueuesQueryQuery, GetServiceQueuesQueryQueryVariables>;
export const GetServiceUsersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getServiceUsersQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contactCenterUserId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"stats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalSessions"}},{"kind":"Field","name":{"kind":"Name","value":"offeredSessions"}},{"kind":"Field","name":{"kind":"Name","value":"missedSessions"}},{"kind":"Field","name":{"kind":"Name","value":"avgCallTime"}},{"kind":"Field","name":{"kind":"Name","value":"loginAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastActionAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastHandledAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastIdleAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetServiceUsersQueryQuery, GetServiceUsersQueryQueryVariables>;
export const ConversationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"conversations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConversationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sid"}},{"kind":"Field","name":{"kind":"Name","value":"queueIds"}}]}}]}}]} as unknown as DocumentNode<ConversationsQuery, ConversationsQueryVariables>;
export const SetUserStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setUserStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSetAvailabilityStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setUserStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}]}}]} as unknown as DocumentNode<SetUserStatusMutation, SetUserStatusMutationVariables>;
export const UpsertCustomerContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCustomerContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactUpsertInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertCustomerContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}]}}]} as unknown as DocumentNode<UpsertCustomerContactsMutation, UpsertCustomerContactsMutationVariables>;
export const AddCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerAddInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<AddCustomerMutation, AddCustomerMutationVariables>;
export const GetCustomerBySearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomerBySearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"memo"}},{"kind":"Field","name":{"kind":"Name","value":"jobRemindersEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"marketingUpdatesEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceStatementNotification"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCustomerBySearchQuery, GetCustomerBySearchQueryVariables>;
export const GetCustomerLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomerLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCustomerLocationsQuery, GetCustomerLocationsQueryVariables>;
export const CustomerJobBookingDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"customerJobBookingDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"jobId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnitName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<CustomerJobBookingDetailsQuery, CustomerJobBookingDetailsQueryVariables>;
export const GetConversationDetailsRecordingAndTranscriptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getConversationDetailsRecordingAndTranscript"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interactionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callTranscript"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"interactionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interactionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordingUri"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"speaker"}}]}}]}}]}}]} as unknown as DocumentNode<GetConversationDetailsRecordingAndTranscriptQuery, GetConversationDetailsRecordingAndTranscriptQueryVariables>;
export const InteractionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"interaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interactionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"interactionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interactionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenantName"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalRef"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAccurate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"updatedById"}},{"kind":"Field","name":{"kind":"Name","value":"updatedByName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"createdByName"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"sentiment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sentimentMood"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"channelClassification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reasonId"}},{"kind":"Field","name":{"kind":"Name","value":"reasonName"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}}]}}]}}]}}]} as unknown as DocumentNode<InteractionQuery, InteractionQueryVariables>;
export const UpdateInteractionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateInteraction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interactionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InteractionUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInteraction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"interactionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interactionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdByName"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"sentiment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sentimentMood"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenantName"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAccurate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"updatedById"}},{"kind":"Field","name":{"kind":"Name","value":"updatedByName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"callTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"callTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"callReasonId"}},{"kind":"Field","name":{"kind":"Name","value":"callReasonName"}}]}}]}}]} as unknown as DocumentNode<UpdateInteractionMutation, UpdateInteractionMutationVariables>;
export const RevertInteractionCallSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"revertInteractionCallSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interactionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revertInteractionCallSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"interactionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interactionId"}}}]}]}}]} as unknown as DocumentNode<RevertInteractionCallSummaryMutation, RevertInteractionCallSummaryMutationVariables>;
export const AgentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AgentsQuery, AgentsQueryVariables>;
export const InteractionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"interactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InteractionFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InteractionsSortInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenantName"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdByName"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"sentiment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sentimentMood"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channelClassification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reasonName"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<InteractionsQuery, InteractionsQueryVariables>;
export const InteractionsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"interactionsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InteractionFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<InteractionsCountQuery, InteractionsCountQueryVariables>;
export const UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"user"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"seatLevel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDetailPersonalLine"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDetailQueues"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDetailOverview"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDetailPermissions"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPossibleQueues"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailPersonalLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seatLevel"}},{"kind":"Field","name":{"kind":"Name","value":"personalLine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"e911Address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recordingPreference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailQueues"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactCenterUserId"}},{"kind":"Field","name":{"kind":"Name","value":"queues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seatLevel"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"hasPermission"}},{"kind":"Field","name":{"kind":"Name","value":"providedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPossibleQueues"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UserQuery, UserQueryVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seatLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSeatLevel"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recordingPreference"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingPreference"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"e911Address"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seatLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seatLevel"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"recordingPreference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recordingPreference"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"e911Address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"e911Address"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seatLevel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDetailPersonalLine"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailPersonalLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seatLevel"}},{"kind":"Field","name":{"kind":"Name","value":"personalLine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"e911Address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recordingPreference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const AddUserQueueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddUserQueue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUserQueue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"queueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDetailQueues"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailQueues"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactCenterUserId"}},{"kind":"Field","name":{"kind":"Name","value":"queues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<AddUserQueueMutation, AddUserQueueMutationVariables>;
export const RemoveUserQueueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUserQueue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUserQueue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"queueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDetailQueues"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailQueues"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactCenterUserId"}},{"kind":"Field","name":{"kind":"Name","value":"queues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<RemoveUserQueueMutation, RemoveUserQueueMutationVariables>;
export const UpdateUserQueueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserQueue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserQueueUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserQueue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"queueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDetailQueues"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailQueues"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactCenterUserId"}},{"kind":"Field","name":{"kind":"Name","value":"queues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<UpdateUserQueueMutation, UpdateUserQueueMutationVariables>;
export const GetPhoneNumbersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPhoneNumbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactCenterPhoneNumbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"workflowIds"}}]}}]}}]} as unknown as DocumentNode<GetPhoneNumbersQuery, GetPhoneNumbersQueryVariables>;
export const UsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seatLevel"}},{"kind":"Field","name":{"kind":"Name","value":"personalLine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"e911Address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"queues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"queues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;
export const ValidateAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"validateAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}]}]}}]} as unknown as DocumentNode<ValidateAddressQuery, ValidateAddressQueryVariables>;
export const VirtualAgentsDefaultSettingsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"virtualAgentsDefaultSettingsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<VirtualAgentsDefaultSettingsQueryQuery, VirtualAgentsDefaultSettingsQueryQueryVariables>;
export const ConnectVirtualAgentAcpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"connectVirtualAgentAcp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectVirtualAgentAcp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}]}]}}]} as unknown as DocumentNode<ConnectVirtualAgentAcpMutation, ConnectVirtualAgentAcpMutationVariables>;
export const DisconnectVirtualAgentAcpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"disconnectVirtualAgentAcp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disconnectVirtualAgentAcp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}]}]}}]} as unknown as DocumentNode<DisconnectVirtualAgentAcpMutation, DisconnectVirtualAgentAcpMutationVariables>;
export const AddQueueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddQueue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueueAddInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addQueue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rolloverSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeout"}}]}}]}}]}}]} as unknown as DocumentNode<AddQueueMutation, AddQueueMutationVariables>;
export const MediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Media"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"media"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<MediaQuery, MediaQueryVariables>;
export const QueueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Queue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"queueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentTimeout"}},{"kind":"Field","name":{"kind":"Name","value":"entrypoints"}},{"kind":"Field","name":{"kind":"Name","value":"forceAway"}},{"kind":"Field","name":{"kind":"Name","value":"holdTreatments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcePositionHoldTreatment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"announceWaitHoldTreatment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pauseHoldTreatment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"wait"}}]}},{"kind":"Field","name":{"kind":"Name","value":"playMediaHoldTreatment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"mediaId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inboundRecording"}},{"kind":"Field","name":{"kind":"Name","value":"memberIds"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"outboundRecording"}},{"kind":"Field","name":{"kind":"Name","value":"rolloverSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeout"}},{"kind":"Field","name":{"kind":"Name","value":"destination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QueueRolloverDestination"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queueId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VoiceMailRolloverDestination"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"vmBoxId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowRolloverDestination"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"routingStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"sessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enteredAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abandonedSessions"}},{"kind":"Field","name":{"kind":"Name","value":"activeRecipientCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeSessionCount"}},{"kind":"Field","name":{"kind":"Name","value":"availableRecipientCount"}},{"kind":"Field","name":{"kind":"Name","value":"averageWait"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedWait"}},{"kind":"Field","name":{"kind":"Name","value":"longestWait"}},{"kind":"Field","name":{"kind":"Name","value":"missedSessions"}},{"kind":"Field","name":{"kind":"Name","value":"recipientCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalSessions"}}]}}]}}]}}]} as unknown as DocumentNode<QueueQuery, QueueQueryVariables>;
export const GetQueuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getQueues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rolloverSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeout"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetQueuesQuery, GetQueuesQueryVariables>;
export const UserPhonesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userPhones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contactCenterUserId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"personalLine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seatLevel"}}]}}]}}]}}]} as unknown as DocumentNode<UserPhonesQuery, UserPhonesQueryVariables>;
export const UpdateQueueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateQueue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueueUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateQueue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"queueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rolloverSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeout"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateQueueMutation, UpdateQueueMutationVariables>;
export const UploadMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UploadMediaMutation, UploadMediaMutationVariables>;
export const CreateWorkflowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateWorkflow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWorkflow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateWorkflowMutation, CreateWorkflowMutationVariables>;
export const GetEntrypointsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEntrypoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entrypoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}}]}}]} as unknown as DocumentNode<GetEntrypointsQuery, GetEntrypointsQueryVariables>;
export const GetWorkflowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkflows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"entrypoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"endpoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasCallForwarding"}},{"kind":"Field","name":{"kind":"Name","value":"hasVoicemail"}},{"kind":"Field","name":{"kind":"Name","value":"isMissingEndpoint"}},{"kind":"Field","name":{"kind":"Name","value":"queueIds"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetWorkflowsQuery, GetWorkflowsQueryVariables>;
export const GetWorkflowsQueuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkflowsQueues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queueIds"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkflowsQueuesQuery, GetWorkflowsQueuesQueryVariables>;
export const GetWorkflowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkflow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"flow"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"entrypoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasCallForwarding"}},{"kind":"Field","name":{"kind":"Name","value":"hasVoicemail"}},{"kind":"Field","name":{"kind":"Name","value":"isMissingEndpoint"}},{"kind":"Field","name":{"kind":"Name","value":"queueIds"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkflowQuery, GetWorkflowQueryVariables>;
export const UpdateWorkflowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateWorkflow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWorkflow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workflowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"entrypoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flow"}}]}}]}}]} as unknown as DocumentNode<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>;
export const DeleteWorkflowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteWorkflow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteWorkflow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workflowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>;
export const ActivateWorkflowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActivateWorkflow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateWorkflow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workflowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<ActivateWorkflowMutation, ActivateWorkflowMutationVariables>;
export const AbandonedCallsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"abandonedCalls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AbandonedCallFollowUpFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AbandonedCallFollowUpSortInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abandonedCallFollowUps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"followUpId"}},{"kind":"Field","name":{"kind":"Name","value":"abandonedCallId"}},{"kind":"Field","name":{"kind":"Name","value":"contactCenterId"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"followUpStatus"}},{"kind":"Field","name":{"kind":"Name","value":"queue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"followUpCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"followUpUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"abandonedCallCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"abandonedCallUpdatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AbandonedCallsQuery, AbandonedCallsQueryVariables>;
export const UpdateFollowUpDismissDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFollowUpDismiss"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"followUpId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FollowUpDismissInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFollowUpDismiss"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"followUpId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"followUpId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"contactCenterId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"dismissReasonId"}},{"kind":"Field","name":{"kind":"Name","value":"followUpType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateFollowUpDismissMutation, UpdateFollowUpDismissMutationVariables>;
export const UpdateFollowUpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateFollowUp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"followUpId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FollowUpUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFollowUp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"followUpId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"followUpId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignedAt"}},{"kind":"Field","name":{"kind":"Name","value":"assignedToId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactCenterId"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"dismissReasonId"}},{"kind":"Field","name":{"kind":"Name","value":"followUpType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateFollowUpMutation, UpdateFollowUpMutationVariables>;
export const CampaignsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"campaigns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignSortInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CampaignsQuery, CampaignsQueryVariables>;
export const QueuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Queues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<QueuesQuery, QueuesQueryVariables>;
export const SecondChanceLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"secondChanceLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SecondChanceLeadFollowUpFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SecondChanceLeadFollowUpSortInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"secondChanceLeadFollowUps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"followUpId"}},{"kind":"Field","name":{"kind":"Name","value":"secondChanceLeadId"}},{"kind":"Field","name":{"kind":"Name","value":"contactCenterId"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"followUpStatus"}},{"kind":"Field","name":{"kind":"Name","value":"secondChanceLeadStatus"}},{"kind":"Field","name":{"kind":"Name","value":"contactInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callReason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sid"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"agentNote"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"followUpCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"followUpUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"secondChanceLeadCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"secondChanceLeadUpdatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<SecondChanceLeadsQuery, SecondChanceLeadsQueryVariables>;